<template>
<div class="view">
    <div class="viewTitle">Pedido Items</div>
    <div class="view-content">
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <InputText label="Codigo pedido" v-model="pedido_items.pei_codigo"></InputText>
                    <InputSelect label="Estados" v-model="pedido_items.pei_estado" :source="estados" itemKey="est_codigo" itemValue="est_codigo" :filterFunction="filterEstados"
                        :labelFunction="setEstado">
                        <template #default="data">
                            {{ setEstado(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect label="Almacenes" v-model="pedido_items.alm_id" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes"
                        :labelFunction="labelAlmacen">
                        <template #default="data">
                            {{ labelAlmacen(data.item) }}
                        </template>
                    </InputSelect>
                </div>
                <br>
                <div class="nj-flex">
                    <Button icon="search" label="Buscar" @click="buscar()"></Button>
                    <Button icon="add" color="green" label="Nuevo" @click="popup({ interfaz: 'registrar' })"></Button>
                </div>
                <br>
                <div class="nj-panel-content">
                    <b-table :data="pedido_items.page.list" @page-change="changePage($event)" :total="pedido_items.page.total" :per-page="pedido_items.page.size"
                        :current-page="pedido_items.page.number" pagination-position="bottom" :pagination-rounded="true" :paginated="true" :backend-pagination="true">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.pei_id }}</b-table-column>
                            <b-table-column label="Codigo" header-class="is-info">{{ props.row.pei_codigo }}</b-table-column>
                            <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.pei_fecha_registro }}</b-table-column>
                            <b-table-column label="Fecha aprobación" header-class="is-info">{{ props.row.pei_fecha_aprobacion }}</b-table-column>
                            <b-table-column label="Estado" header-class="is-info">
                                <b-tag :class="props.row.pei_estado_styles">{{ props.row.pei_estado_nombre }}</b-tag>
                            </b-table-column>
                            <b-table-column label="Proyecto" header-class="is-info">{{ props.row.pry_nombre }}</b-table-column>
                            <b-table-column label="Almacen destino" header-class="is-info">{{ props.row.alm_nombre }}</b-table-column>
                            <b-table-column label="Opciones" header-class="is-info">
                                <div class="nj-flex">
                                    <Button title="Ver" icon="info" @click="popup({ interfaz: 'ver', pei_id: props.row.pei_id })"></Button>
                                    <Button title="Modificar" icon="edit" @click="popup({ interfaz: 'modificar', pei_id: props.row.pei_id })" v-if="activarOpcion('modificar', props.row)"></Button>
                                    <Button title="Eliminar" icon="delete" @click="eliminar(props.row.pei_id)" v-if="activarOpcion('eliminar', props.row)"></Button>
                                    <Button title="Solicitar Aprobacion" icon="email" @click="solicitarAprobacion(props.row.pei_id)" v-if="activarOpcion('solicitar', props.row)"></Button>
                                    <Button title="Aprobar" icon="review" @click="popup({ interfaz: 'aprobar', pei_id: props.row.pei_id })" activationCode="aprobar_pedido_items"
                                        v-if="activarOpcion('aprobar', props.row)"></Button>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
    <RegistrarPedidoItems v-if="interfaz == 'registrar'" @close="popup($event)"></RegistrarPedidoItems>
    <ModificarPedidoItems v-if="interfaz == 'modificar'" @close="popup($event)" :pei_id="pei_id"></ModificarPedidoItems>
    <AprobarPedidoItems v-if="interfaz == 'aprobar'" @close="popup($event)" :pei_id="pei_id"></AprobarPedidoItems>
    <VerPedidoItems v-if="interfaz == 'ver'" @close="popup($event)" :pei_id="pei_id"></VerPedidoItems>
</div>
</template>
<script>
import { EstadoEnum } from "../../constants"
import { PedidoItemsService, ResponseStatus, UsuarioService } from "../../services"
import OpcionesService from "../../services/OpcionesService"
import { Confirm } from "../../util"
import Toast from "../../util/toast"
import { Button, InputSelect, InputText } from "../components"
import AprobarPedidoItems from "./AprobarPedidoItems.vue"
import ModificarPedidoItems from "./ModificarPedidoItems.vue"
import RegistrarPedidoItems from "./RegistrarPedidoItems.vue"
import VerPedidoItems from "./VerPedidoItems.vue"

export default {
    name: "PedidoItems",
    components: {
        Button,
        InputText,
        InputSelect,
        RegistrarPedidoItems,
        ModificarPedidoItems,
        AprobarPedidoItems,
        VerPedidoItems,
    },
    data() {
        return {
            pedido_items: {
                pei_estado: null,
                alm_id: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0,
                    list: []
                },
            },
            pei_id: null,
            interfaz: "none",
            almacenes: [],
            estados: []
        }
    },
    methods: {
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        activarOpcion(opcion, item) {
            let condicion = false
            switch (opcion) {
                case "modificar":
                    condicion = item.pei_estado == EstadoEnum.CREADO.est_codigo || item.pei_estado == EstadoEnum.POR_APROBAR.est_codigo
                    break
                case "eliminar":
                    condicion = item.pei_estado == EstadoEnum.CREADO.est_codigo || item.pei_estado == EstadoEnum.POR_APROBAR.est_codigo
                    break
                case "solicitar":
                    condicion = item.pei_estado == EstadoEnum.CREADO.est_codigo
                    break
                case "aprobar":
                    condicion = item.pei_estado == EstadoEnum.CREADO.est_codigo || item.pei_estado == EstadoEnum.POR_APROBAR.est_codigo
                    break
            }
            return condicion
        },
        filterEstados(items, param) {
            if (param != null) {
                return items.filter(item => item.est_nombre.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        setEstado(item) {
            return item.est_nombre
        },
        changePage(number) {
            this.pedido_items.page.number = number
            this.buscar()
        },
        buscar() {
            PedidoItemsService
                .paginar({
                    pedido_items: this.pedido_items
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.pedido_items.page = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                }).catch(error => {
                    Toast.error(error)

                })
        },
        popup({
            interfaz,
            buscar = false,
            pei_id = null
        }) {
            this.interfaz = interfaz
            this.pei_id = pei_id
            if (buscar) {
                this.buscar()
            }
        },
        eliminar(pei_id) {
            Confirm.show({
                message: "¿Deseea eliminar el pedido de items?",
                action: () => {
                    PedidoItemsService
                        .eliminar({
                            pedido_items: {
                                pei_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.buscar()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        solicitarAprobacion(pei_id) {
            const request = {
                pedido_items: {
                    pei_id
                }
            }
            PedidoItemsService
                .solicitarAprobacion(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        OpcionesService
            .getOpciones({
                estado: {
                    modulo: "pedidoItems"
                },
                almacen: {
                    pry_id: UsuarioService.getUsuario().usu_nivel == 1
                        ? null
                        : UsuarioService.getUsuario().pry_id
                },
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = response.data.estados
                    this.almacenes = response.data.almacenes
                    // verificando si se solicita mostrar el pedido desde la url
                    if (
                        this.$route.params.id != undefined
                        && this.$route.params.id != null
                        && this.$route.params.action != undefined
                        && this.$route.params.action != null) {
                        this.popup({
                            pei_id: this.$route.params.id,
                            interfaz: this.$route.params.action,
                        })
                    }
                    else {
                        // realizando la busqueda por defecto
                        this.buscar()
                    }
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>